
import { ResourceModel } from "src/app/core/models/resource.model";

export class User extends ResourceModel<User> {
  email!: string;
  firstName!: string;
  lastName!: string;
  isLoggedIn!: boolean;
  roles!: Array<any>;
  groups!:Array<any>;
}